import React from 'react';
import {
  ArrayInput,
  Edit,
  NumberInput,
  SaveButton,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  Toolbar,
  minValue,
  number,
  required,
  useNotify,
  useRedirect,
} from 'react-admin';

import { useTitle } from '@src/hooks/useTitle';
import { DashboardResources } from '@src/types';

const RepairPricingEditToolbar = () => (
  <Toolbar>
    <SaveButton />
  </Toolbar>
);

const RepairPricingEdit = () => {
  const { title } = useTitle('Edit Repair Pricing Criteria');
  const notify = useNotify();
  const redirect = useRedirect();

  return (
    <Edit
      title={title}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify('Repair pricing criteria updated', { type: 'success' });
          redirect('list', DashboardResources.RepairPricing);
        },
        onError: (error: unknown) => {
          const message = error instanceof Error ? error.message : 'Failed to update criteria';
          notify(`Error: ${message}`, { type: 'error' });
        },
      }}
    >
      <SimpleForm toolbar={<RepairPricingEditToolbar />}>
        <TextInput source="problemAttributeName" label="Problem" disabled fullWidth />
        <TextInput source="locationAttributeName" label="Location" disabled fullWidth />
        <TextInput source="severityAttributeName" label="Severity" disabled fullWidth />
        <NumberInput
          source="price"
          label="Price (cents)"
          validate={[required(), number(), minValue(0)]}
          helperText="Amount in cents, e.g. 5000 = $50.00"
          fullWidth
        />
        <TextInput
          source="rubricCode"
          label="Rubric Code"
          fullWidth
          helperText="Leave empty to match all rubric codes"
        />
        <TextInput
          source="vendorCountryCode"
          label="Vendor Country Code"
          fullWidth
          helperText="ISO 2-letter code, e.g. US. Leave empty to match all countries."
        />
        <ArrayInput source="tags" label="Category Filters">
          <SimpleFormIterator inline>
            <TextInput source="tag" label="Tag" validate={required()} helperText={false} />
            <TextInput source="name" label="Value" validate={required()} helperText={false} />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  );
};

export default RepairPricingEdit;
